import React from "react";
import { Stack, Text } from "@fluentui/react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ICatalystEngagedPartners } from "../../../../interfaces/Catalyst.interfaces";

export interface CatalystEngagedPartnersTableProps {
  data?: ICatalystEngagedPartners[];
  isLoading?: boolean;
}

const columns: GridColDef[] = [
  {
    field: "tenantId",
    headerName: "Tenant ID",
    width: 240,
    minWidth: 210,
  },
  {
    field: "customerName",
    headerName: "Customer Names",
    flex: 1.45,
    minWidth: 220,
  },
  {
    field: "workloadName",
    headerName: "Tenant Names",
    flex: 1.4,
    minWidth: 210,
  },
  {
    field: "workload",
    headerName: "Product",
    width: 130,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "partnersEngaged",
    headerName: "Partners Engaged",
    flex: 1.45,
    minWidth: 225,
  },
];

export const CatalystEngagedPartnersTable: React.FC<CatalystEngagedPartnersTableProps> = ({
  data,
  isLoading = false,
}) => {
  const rows = (data || []).map((item, index) => ({
    id: index,
    tenantId: item.tenantId ?? "-",
    customerName: item.customerName ?? "-",
    workloadName: item.workloadName ?? "-",
    workload: item.workload ?? "-",
    partnersEngaged: item.partnersEngaged ?? "-",
  }));

  return (
    <Stack tokens={{ childrenGap: 8 }}>
      <Text variant="large" styles={{ root: { fontWeight: 600 } }}>
        Engaged Partners
      </Text>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isLoading}
        autoHeight
        rowHeight={36}
        columnHeaderHeight={56}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10]}
        initialState={{
          pagination: { paginationModel: { pageSize: 5 } },
        }}
        slotProps={{
          loadingOverlay: {
            variant: "skeleton" as any,
            noRowsVariant: "skeleton" as any,
          },
        }}
        sx={{
          border: "none",
          "& .MuiDataGrid-columnHeaders": {
            fontWeight: 700,
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
            paddingLeft: 2,
            paddingRight: 2,
          },
          "& .MuiDataGrid-row:hover": { backgroundColor: "#F3F2F1" },
        }}
      />
    </Stack>
  );
};
